<template>
  <keep-alive>
    <div class="detail-w">
      <div class="editor"></div>
      <el-upload
        ref="upload"
        v-show="false"
        class="w-80px h-80px border-1 border-dashed border-hex-d9d9d9 rounded-6px cursor-pointer relative overflow-hidden flex justify-center items-center avatar-uploader"
        action=""
        :before-upload="getFileContent"
        :http-request="uploadImage"
        :show-file-list="false"
        :accept="accept"
      >
      </el-upload>
      <el-dialog
        v-dialogDrag
        title="查看图片信息"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        class="small-dialog"
        :append-to-body="true"
      >
        <el-row v-for="(item, index) in imgList" :key="index" :gutter="15" class="h-200px mb-20px">
          <el-col :span="12" class="h-full border-color-default border-1px">
            <el-image
              :src="item.url"
              :preview-src-list="[item.url]"
              class="w-full h-full"
              fit="contain"
            ></el-image>
          </el-col>
          <el-col :span="12">
            <div>宽度：<el-input v-model="item.width" size="small" readonly /></div>
            <div class="mt-15px">
              高度：<el-input v-model="item.height" size="small" readonly />
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </keep-alive>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import QuillBetterTable from 'quill-better-table'
import 'quill-better-table/dist/quill-better-table.css'
// import BlotFormatter from 'quill-blot-formatter'

/* eslint-disable */
const fileApi = new FileApi()
Quill.register({
  'modules/better-table': QuillBetterTable,
})
const titleConfig = {
  'ql-bold': '加粗',
  'ql-color': '颜色',
  'ql-font': '字体',
  'ql-code': '插入代码',
  'ql-italic': '斜体',
  'ql-link': '添加链接',
  'ql-background': '颜色',
  'ql-size': '字体大小',
  'ql-strike': '删除线',
  'ql-script': '上标/下标',
  'ql-underline': '下划线',
  'ql-blockquote': '引用',
  'ql-header': '标题',
  'ql-indent': '缩进',
  'ql-list': '列表',
  // 'ql-align': '文本对齐',
  'ql-direction': '文本方向',
  'ql-code-block': '代码块',
  'ql-formula': '公式',
  'ql-image': '图片',
  'ql-video': '视频',
  'ql-clean': '清除字体样式',
  'ql-upload': '文件',
  'ql-table': '插入表格',
  'ql-table-insert-row': '插入行',
  'ql-table-insert-column': '插入列',
  'ql-table-delete-row': '删除行',
  'ql-table-delete-column': '删除列',
  'ql-lineheight': '行高',
  'ql-letterspacing': '字距',
  'ql-typography': '智能排版',
  'ql-image-size': '查看图片信息',
}
const fontSizeStyle = Quill.import('attributors/style/size')
fontSizeStyle.whitelist = ['12px', '14px', '16px', '18px', '22px', '26px', '30px', '36px', '42px']
Quill.register(fontSizeStyle, true)

// 设置行高
const Parchment = Quill.import('parchment')
class StyleAttributor extends Parchment.Attributor {}
const lineHeightStyle = new StyleAttributor('lineheight', 'ql-lineheight', {
  scope: Parchment.Scope.INLINE,
  whitelist: ['1', '1.5', '1.8', '2', '3', '4', '5'],
})
Quill.register({ 'formats/lineHeight': lineHeightStyle }, true)

// 设置字距
const letterSpacingStyle = new StyleAttributor('letterspacing', 'ql-letterspacing', {
  scope: Parchment.Scope.INLINE,
  whitelist: ['0', '0.25', '0.5', '1', '1.5', '2', '2.5', '3', '4', '5'],
})
Quill.register({ 'formats/letterspacing': letterSpacingStyle }, true)

// 设置字体
const fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif']
const Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)
// 图片缩放
// Quill.register('modules/blotFormatter', BlotFormatter)
export default {
  name: 'Editor',
  props: {
    content: null,
  },
  data() {
    let that = this
    return {
      dialogVisible: false,
      imgList: [],
      accept: 'jpg,png',
      imageFile: '',
      file1: '',
      fileId: '',
      currentStrLength: 0, // 当前字数长度
      quill: null,
      options: {
        preserveWhitespace: true,
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'], // 引用，代码块
              [{ size: fontSizeStyle.whitelist }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
              [{ lineheight: ['1', '1.5', '1.8', '2', '3', '4', '5'] }], // 行高
              [{ letterspacing: ['0', '0.25', '0.5', '1', '1.5', '2', '2.5', '3', '4', '5'] }], // 字距
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ color: [] }, { background: [] }],
              [{ font: fonts }],
              // [{ align: [] }],
              [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
              ['clean'],
              ['image'], // 上传图片、上传视频
              [
                { table: 'TD' },
                // { 'table-insert-row': 'TIR' },
                // { 'table-insert-column': 'TIC' },
                // { 'table-delete-row': 'TDR' },
                // { 'table-delete-column': 'TDC' },
              ],
              ['typography'],
              ['image-size'],
            ],
            handlers: {
              image: function(value) {
                if (value) {
                  that.handleMockUpload()
                } else {
                  that.quill.format('image', false)
                }
              },
              table: function(val) {
                this.quill.getModule('better-table').insertTable(2, 3)
              },
              typography: function() {
                const richText = document.querySelector('.ql-editor')?.children
                _.forEach(richText, (item, index) => {
                  if (item.nodeName === 'P') {
                    if (item.children.length === 0) {
                      if (!item.isDesc) {
                        // 获取当前段落的前导空格
                        const currentIndent = item.innerHTML.match(/^\s*/)[0]
                        const spacesToAdd = 4 - currentIndent.length
                        if (spacesToAdd > 0) {
                          const indent = ' '.repeat(spacesToAdd)
                          item.innerHTML = indent + item.innerHTML
                        }
                        item.setAttribute('ql-lineheight', '1.8')
                      }
                    } else if (
                      item.children[0].nodeName === 'SPAN' ||
                      item.children[0].nodeName === 'STRONG'
                    ) {
                      const span = item.children[0]
                      if (span.children.length === 0) {
                        if (!item.isDesc) {
                          // 获取当前段落的前导空格
                          const currentIndent = span.innerHTML.match(/^\s*/)[0]
                          const spacesToAdd = 4 - currentIndent.length
                          if (spacesToAdd > 0) {
                            const indent = ' '.repeat(spacesToAdd)
                            span.innerHTML = indent + span.innerHTML
                          }
                          item.setAttribute('ql-lineheight', '1.8')
                        }
                      }
                    }
                    _.forEach(item.children, (child) => {
                      if (
                        child.nodeName === 'IMG' ||
                        (child.nodeName === 'SPAN' &&
                          child.children.length &&
                          child.children[0].nodeName === 'IMG')
                      ) {
                        item.classList.add('ql-align-center')
                        const nextNode = richText[index + 1]
                        if (nextNode && nextNode.innerText.length < 20) {
                          nextNode.classList.add('ql-align-center')
                          nextNode.isDesc = true
                        }
                      }
                    })
                  }
                })
                that.$nextTick(() => {
                  that.$emit('typography')
                })
              },
              'image-size': () => {
                const imgNodeList = this.quill.container.getElementsByTagName('img')
                this.imgList = []
                _.forEach(imgNodeList, (item) => {
                  this.imgList.push({
                    width: item.offsetWidth,
                    height: item.offsetHeight,
                    url: item.getAttribute('src'),
                  })
                })
                if (this.imgList.length) {
                  this.dialogVisible = true
                } else {
                  this.$message.warning('未获取到图片')
                }
              },
              // 'table-insert-row': function() {
              //   this.quill.getModule('table').insertRowBelow()
              // },
              // 'table-insert-column': function() {
              //   this.quill.getModule('table').insertColumnRight()
              // },
              // 'table-delete-row': function() {
              //   this.quill.getModule('table').deleteRow()
              // },
              // 'table-delete-column': function() {
              //   this.quill.getModule('table').deleteColumn()
              // },
            },
          },
          table: false,
          'better-table': {
            operationMenu: {
              items: {
                insertColumnRight: { text: '右边插入一列' },
                insertColumnLeft: { text: '左边插入一列' },
                insertRowUp: { text: '上边插入一行' },
                insertRowDown: { text: '下边插入一行' },
                mergeCells: { text: '合并单元格' },
                unmergeCells: { text: '拆分单元格' },
                deleteColumn: { text: '删除列' },
                deleteRow: { text: '删除行' },
                deleteTable: { text: '删除表格' },
              },
              color: {
                colors: ['green', 'red', 'yellow', 'blue', 'white'],
                text: '背景色:',
              },
            },
          },
          // blotFormatter: {
          //   toolbar: {
          //     mainClassName: 'blot-formatter__toolbar',
          //   },
          // },
        },
        placeholder: '',
      },
    }
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  methods: {
    addQuillTitle() {
      const oToolBar = document.querySelector('.ql-toolbar')
      if (!oToolBar) return
      const aButton = oToolBar.querySelectorAll('button')
      const aSelect = oToolBar.querySelectorAll('select')
      aButton.forEach(function(item) {
        if (item.className === 'ql-align') {
          switch (item.value) {
            case 'center':
              item.title = '居中对齐'
              break
            case 'right':
              item.title = '居右对齐'
              break
            case 'justify':
              item.title = '两端对齐'
              break
            default:
              item.title = '居左对齐'
              break
          }
        } else if (item.className === 'ql-script') {
          item.value === 'sub' ? (item.title = '下标') : (item.title = '上标')
        } else if (item.className === 'ql-indent') {
          item.value === '+1' ? (item.title = '向右缩进') : (item.title = '向左缩进')
        } else {
          item.title = titleConfig[item.classList[0]]
        }
      })
      aSelect.forEach(function(item) {
        item.parentNode.title = titleConfig[item.classList[0]]
      })
    },
    getContentData() {
      return this.quill.getContents()
    },
    handleMockUpload() {
      this.$refs.upload.$el.querySelector('input[type="file"]').click()
    },
    // 获取上传的内容
    getFileContent(file) {
      if (
        !this.accept.includes(
          file.name
            .split('.')
            .at(-1)
            .toLowerCase()
        )
      ) {
        this.$message.warning(`请上传图片格式文件, ${this.accept}`)
        return false
      }
      this.file1 = file
      return true
    },
    async uploadImage() {
      const [err, res] = await fileApi.upload({
        files: [this.file1],
        authLevel: 2,
      })
      if (!err) {
        const item = (res && res[0]) || {}
        this.fileId = item.id
        this.handleUploadImageSuccess(this.fileId)
      }
    },
    handleUploadImageSuccess(fileId) {
      if (!fileId) return
      this.value = `${this.fileUrl}${fileId}`
      let quill = this.quill
      let length = quill.getSelection().index
      // 插入图片 res.info为服务器返回的图片地址
      quill.insertEmbed(length, 'image', this.value)
      // 调整光标到最后
      quill.setSelection(length + 1)
    },
  },
  mounted() {
    const dom = this.$el.querySelector('.editor')
    dom.style.minHeight = '200px' // 设置富文本高度
    this.quill = new Quill(dom, this.options)
    this.$nextTick(() => {
      this.$el.querySelector('.ql-editor').innerHTML = this.content || ''
    })
    this.quill.on('text-change', () => {
      this.$emit('change', this.quill.root.innerHTML)
    })
    this.quill.on('selection-change', () => {
      // 隐藏图片缩放对齐框
      const resizeImgTool = this.$el.querySelector('.blot-formatter__overlay')
      if (resizeImgTool) {
        resizeImgTool.style.display = 'none'
      }
    })
    this.quill.root.addEventListener('keydown', (event) => {
      // 解决段落空格缩进后回车换行无缩进问题
      if (event.keyCode === 13) {
        // 按下回车键
        var range = this.quill.getSelection()
        var currentLine = this.quill.getLine(range.index)
        var lineText = this.quill.getLine(range.index - 1)[0].domNode.textContent
        // 判断当前光标所在的位置是否在段落的开头，并且前面有空格
        if (range.index === currentLine[0].offset() && lineText.trim() === '') {
          // 获取前面空格的数量
          var indent = lineText.match(/^\s*/)
          // 在新的段落中插入相同数量的空格
          this.quill.insertText(range.index, indent[0])
          // 阻止默认的回车键行为
          event.preventDefault()
        }
      }
    })
    this.$el.querySelector('.ql-typography').innerHTML =
      '<i class="iconfont icon-yxr-wheelbaseMeasurement text-12px text-[#000] block"></i>'
    this.$el.querySelector('.ql-image-size').innerHTML =
      '<i class="iconfont icon-yxr-firstPersonRoaming text-12px text-[#000] block"></i>'
    // this.$el.querySelector(
    //   '.ql-table-insert-row'
    // ).innerHTML = `<svg t="1591862376726" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6306" width="18" height="200"><path d="M500.8 604.779L267.307 371.392l-45.227 45.27 278.741 278.613L779.307 416.66l-45.248-45.248z" p-id="6307"></path></svg>`
    // this.$el.querySelector(
    //   '.ql-table-insert-column'
    // ).innerHTML = `<svg t="1591862238963" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6509" width="18" height="200"><path d="M593.450667 512.128L360.064 278.613333l45.290667-45.226666 278.613333 278.762666L405.333333 790.613333l-45.226666-45.269333z" p-id="6510"></path></svg>`
    // this.$el.querySelector(
    //   '.ql-table-delete-row'
    // ).innerHTML = `<svg t="1591862253524" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6632" width="18" height="200"><path d="M500.8 461.909333L267.306667 695.296l-45.226667-45.269333 278.741333-278.613334L779.306667 650.026667l-45.248 45.226666z" p-id="6633"></path></svg>`
    // this.$el.querySelector(
    //   '.ql-table-delete-column'
    // ).innerHTML = `<svg t="1591862261059" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6755" width="18" height="200"><path d="M641.28 278.613333l-45.226667-45.226666-278.634666 278.762666 278.613333 278.485334 45.248-45.269334-233.365333-233.237333z" p-id="6756"></path></svg>`
    this.addQuillTitle()
  },
  activated() {
    this.quill.setContents({})
  },
}
</script>
<style lang="scss" scoped>
::v-deep .ql-snow {
  .blot-formatter__toolbar {
    display: none;
  }
  .ql-picker.ql-size {
    .ql-picker-label[data-value='12px']::before,
    .ql-picker-item[data-value='12px']::before {
      content: '12px';
    }
    .ql-picker-label[data-value='14px']::before,
    .ql-picker-item[data-value='14px']::before {
      content: '14px';
    }
    .ql-picker-label[data-value='16px']::before,
    .ql-picker-item[data-value='16px']::before {
      content: '16px';
    }
    .ql-picker-label[data-value='18px']::before,
    .ql-picker-item[data-value='18px']::before {
      content: '18px';
    }
    .ql-picker-label[data-value='22px']::before,
    .ql-picker-item[data-value='22px']::before {
      content: '22px';
    }
    .ql-picker-label[data-value='26px']::before,
    .ql-picker-item[data-value='26px']::before {
      content: '26px';
    }
    .ql-picker-label[data-value='30px']::before,
    .ql-picker-item[data-value='30px']::before {
      content: '30px';
    }
    .ql-picker-label[data-value='36px']::before,
    .ql-picker-item[data-value='36px']::before {
      content: '36px';
    }
    .ql-picker-label[data-value='42px']::before,
    .ql-picker-item[data-value='42px']::before {
      content: '42px';
    }
  }
  .ql-picker.ql-lineheight {
    width: 50px;
    .ql-picker-label[data-value='1']::before,
    .ql-picker-item[data-value='1']::before {
      content: '1';
    }
    .ql-picker-label[data-value='1.5']::before,
    .ql-picker-item[data-value='1.5']::before {
      content: '1.5';
    }
    .ql-picker-label[data-value='1.8']::before,
    .ql-picker-item[data-value='1.8']::before {
      content: '1.8';
    }
    .ql-picker-label[data-value='2']::before,
    .ql-picker-item[data-value='2']::before {
      content: '2';
    }
    .ql-picker-label[data-value='3']::before,
    .ql-picker-item[data-value='3']::before {
      content: '3';
    }
    .ql-picker-label[data-value='4']::before,
    .ql-picker-item[data-value='4']::before {
      content: '4';
    }
    .ql-picker-label[data-value='5']::before,
    .ql-picker-item[data-value='5']::before {
      content: '5';
    }
  }
  .ql-picker.ql-letterspacing {
    width: 50px;
    .ql-picker-label[data-value='0']::before,
    .ql-picker-item[data-value='0']::before {
      content: '0';
    }
    .ql-picker-label[data-value='0.25']::before,
    .ql-picker-item[data-value='0.25']::before {
      content: '0.25';
    }
    .ql-picker-label[data-value='0.5']::before,
    .ql-picker-item[data-value='0.5']::before {
      content: '0.5';
    }
    .ql-picker-label[data-value='1']::before,
    .ql-picker-item[data-value='1']::before {
      content: '1';
    }
    .ql-picker-label[data-value='1.5']::before,
    .ql-picker-item[data-value='1.5']::before {
      content: '1.5';
    }
    .ql-picker-label[data-value='2']::before,
    .ql-picker-item[data-value='2']::before {
      content: '2';
    }
    .ql-picker-label[data-value='2.5']::before,
    .ql-picker-item[data-value='2.5']::before {
      content: '2.5';
    }
    .ql-picker-label[data-value='3']::before,
    .ql-picker-item[data-value='3']::before {
      content: '3';
    }
    .ql-picker-label[data-value='4']::before,
    .ql-picker-item[data-value='4']::before {
      content: '4';
    }
    .ql-picker-label[data-value='5']::before,
    .ql-picker-item[data-value='5']::before {
      content: '5';
    }
  }
  .ql-picker.ql-font {
    .ql-picker-label[data-value='SimSun']::before,
    .ql-picker-item[data-value='SimSun']::before {
      content: '宋体';
      font-family: 'SimSun';
    }
    .ql-picker-label[data-value='SimHei']::before,
    .ql-picker-item[data-value='SimHei']::before {
      content: '黑体';
      font-family: 'SimHei';
    }
    .ql-picker-label[data-value='Microsoft-YaHei']::before,
    .ql-picker-item[data-value='Microsoft-YaHei']::before {
      content: '微软雅黑';
      font-family: 'Microsoft YaHei';
    }
    .ql-picker-label[data-value='KaiTi']::before,
    .ql-picker-item[data-value='KaiTi']::before {
      content: '楷体';
      font-family: 'KaiTi';
    }
    .ql-picker-label[data-value='FangSong']::before,
    .ql-picker-item[data-value='FangSong']::before {
      content: '仿宋';
      font-family: 'FangSong';
    }
    .ql-picker-label[data-value='Arial']::before,
    .ql-picker-item[data-value='Arial']::before {
      content: 'Arial';
      font-family: 'Arial';
    }
    .ql-picker-label[data-value='sans-serif']::before,
    .ql-picker-item[data-value='sans-serif']::before {
      content: 'sans-serif';
      font-family: 'sans-serif';
    }
  }
}
</style>
